'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _VstInput = require('./VstInput');

var _VstInput2 = _interopRequireDefault(_VstInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'vst-input-button' },
    children
  );
};
Button.propTypes = {
  children: _propTypes2.default.node.isRequired
};

var Addon = function Addon(_ref2) {
  var children = _ref2.children;
  return _react2.default.createElement(
    'div',
    { className: 'vst-input-addon' },
    children
  );
};
Addon.propTypes = {
  children: _propTypes2.default.node.isRequired
};

var Input = function Input(props) {
  return _react2.default.createElement(_VstInput2.default, _extends({}, props, { ignoreLabel: true }));
};

var VstInputGroup = function VstInputGroup(_ref3) {
  var children = _ref3.children,
      label = _ref3.label,
      height = _ref3.height;
  return _react2.default.createElement(
    'div',
    { className: 'vst-input-group' },
    _react2.default.createElement(
      'fieldset',
      null,
      label && _react2.default.createElement(
        'legend',
        null,
        label
      ),
      _react2.default.createElement(
        'div',
        { className: 'vst-input-row', style: { height: height } },
        children
      )
    )
  );
};

VstInputGroup.propTypes = {
  children: _propTypes2.default.node.isRequired,
  label: _propTypes2.default.string.isRequired,
  height: _propTypes2.default.string
};
VstInputGroup.defaultProps = {
  label: null,
  height: '32px'
};

VstInputGroup.Addon = Addon;
VstInputGroup.Button = Button;
VstInputGroup.Input = Input;

exports.default = VstInputGroup;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstInputGroup.js
 **/